"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptLegalsInput = void 0;
// External
const React = require("react");
const react_1 = require("react");
const react_query_1 = require("react-query");
const guid_1 = require("../../../../apis/spg/util/guid");
const useClient_1 = require("../../../../hooks/useClient");
const Collapse_1 = require("../../atoms/Collapse");
const Legals_1 = require("../../atoms/Legals");
const Loader_1 = require("../../atoms/Loader");
const BooleanInput_1 = require("../BooleanInput");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "AcceptLegalsInput");
/**
 * Input to present a legal document and collect consent.
 */
const AcceptLegalsInput = ({ onInputChange, value, disabled }) => {
    const [showTerms, setShowTerms] = (0, react_1.useState)(false);
    const client = (0, useClient_1.useClient)();
    /*
     react-query uses a key to distinguish between requests. Requests with the
     same key are considered the same and therefore may return a cached result.
     This causes problems with testing, where we want to demonstrate normal
     use, failure state, and usage within the Next & Zam clients.
     For this reason, we will generate a unique key for each instance of this
     component, so that to react-query each call to
     'client.legals.retrieveTermsAndConditions' is seen as distinct.
     Whilst there is a performance tradeoff to this approach, the overall cost is
     minimal, as it will only affect the (relatively) small request for the terms
     & conditions JSON object.
    */
    const key = (0, react_1.useMemo)(guid_1.createGuid, []);
    const { data, isLoading, isError, refetch } = (0, react_query_1.useQuery)(`acceptLegals-${key}`, () => client.legals.retrieveTermsAndConditions());
    return (React.createElement("div", { "data-test": "accept-legals-input" },
        React.createElement("div", { style: { paddingBottom: "10px" } },
            isLoading && (React.createElement(React.Fragment, null,
                React.createElement(Loader_1.Loader, null),
                " Loading terms...")),
            isError && (React.createElement("div", { className: css("error") },
                "Unable to fetch details, please",
                " ",
                React.createElement("span", { className: css("error_retry"), onClick: () => refetch() }, "try again."))),
            data && (React.createElement(React.Fragment, null,
                React.createElement("a", { onClick: () => setShowTerms(x => !x) }, showTerms ? "Hide details" : "View details"),
                React.createElement(Collapse_1.Collapse, { isOpened: showTerms },
                    React.createElement("div", { "data-test": "legals" },
                        React.createElement(Legals_1.Legals, { lead: data.lead, sections: data.sections })))))),
        React.createElement("div", { "data-test": "boolean-input" },
            React.createElement(BooleanInput_1.BooleanInput, { onInputChange: onInputChange, value: value, disabled: !data || disabled }))));
};
exports.AcceptLegalsInput = AcceptLegalsInput;
//# sourceMappingURL=index.js.map